import { render, staticRenderFns } from "./printSale.vue?vue&type=template&id=21cc4a58&scoped=true&"
import script from "./printSale.vue?vue&type=script&lang=js&"
export * from "./printSale.vue?vue&type=script&lang=js&"
import style0 from "./printSale.vue?vue&type=style&index=0&id=21cc4a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc4a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
